import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ProductsList from "./ProductsList";
import Scroller from "./Scroller";
import ActionButton from "../ActionButton";
import ReactPixel from "@bettercart/react-facebook-pixel";
import ReactGA from "react-ga4";
import SnapchatPixel from "react-snapchat-pixel";
import TiktokPixel from "../../tiktok-pixel";
import TwitterPixel from "../../TwitterPixel";

import { GTM } from "../../App";
import {
  FacebookInitiateCheckout,
  generateUniqueID,
  TikTokInitiateCheckout,
} from "../../Helpers/analytics";
import { shouldStartWithOrderPassContact } from "../../Helpers/orderPass";

class index extends Component {
  handleDialogContinue = () => {
    this.props.history.push(
      shouldStartWithOrderPassContact(
        this.props.settings,
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
        this.props.orderPassGuestBypassPhone,
      )
        ? "/checkout/details"
        : "/checkout/confirmation",
    );

    if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
      const eventId = generateUniqueID(10);
      ReactPixel.track(
        "InitiateCheckout",
        {
          event_id: eventId,
          currency: this.props.settings.currency_iso,
          value: this.props.cart.price,
        },
        { eventID: eventId },
      );
      if (this.props.settings.enable_conversion_api) {
        FacebookInitiateCheckout(eventId);
      }
    }
    if (
      this.props.settings.enable_snap_pixel &&
      this.props.settings.snap_pixel
    ) {
      SnapchatPixel.track("START_CHECKOUT", { integration: "ordable" });
    }
    if (
      this.props.settings.enable_google_analytics &&
      this.props.settings.google_analytics
    ) {
      ReactGA.event({
        category: "orders",
        action: "customer reviews purchase",
        label: "begin_checkout",
      });
    }
    if (GTM) {
      GTM.track("begin_checkout", {
        ecommerce: {
          currency: this.props.settings.currency_iso,
          value: this.props.cart.price,
          items: this.props.cart.cart.map((item) => {
            return {
              item_id: item.id,
              item_name: item.name,
              currency: this.props.settings.currency_iso,
              price: item.total_price + item.quantityExcludedOptionsTotal,
              quantity: item.quantity,
            };
          }),
        },
      });
    }
    if (
      this.props.settings.enable_tiktok_pixel &&
      this.props.settings.tiktok_pixel
    ) {
      if (this.props.settings.enable_conversion_api_tiktok) {
        TikTokInitiateCheckout();
      }
    }
    if (TwitterPixel.isInitialized()) {
      if (this.props.settings.twitter_events["Checkout Initiated"]) {
        TwitterPixel.track(
          this.props.settings.twitter_events["Checkout Initiated"],
        );
      }
    }
  };

  render() {
    const { categories, cart, language, settings, selectedCategory } =
      this.props;
    let totalCartLength = cart.cart.length + cart.promo_items.length;
    let customTexts = this.props.settings.custom_texts;

    return (
      <div
        style={{
          backgroundColor: "white",
          marginBottom: 20,
        }}
      >
        {/* {!settings.hide_bubbles && <Scroller />} */}
        {/* {selectedCategory === "all" ? (
          categories.map((cat) => (
            <div id={cat.id}>
              <ProductsList
                history={this.props.history}
                category={cat}
                key={"bubbleCategory" + cat.id}
              />
            </div>
          ))
        ) : (
          <div id={selectedCategory.id}>
            <ProductsList
              history={this.props.history}
              category={selectedCategory}
            />
          </div>
        )} */}

        {categories.map((cat) => (
          <div id={cat.id}>
            <ProductsList
              history={this.props.history}
              category={cat}
              key={"bubbleCategory" + cat.id}
            />
          </div>
        ))}
        {totalCartLength > 0 ? (
          <ActionButton
            action={
              language == "english"
                ? customTexts.review_order
                : customTexts.review_order_ar
            }
            onClick={() => {
              this.handleDialogContinue();
            }}
            total={this.props.cart.price.toFixed(settings.currency_decimals)}
            quantity={totalCartLength > 0 ? totalCartLength : null}
          />
        ) : null}
        {this.props.settings.is_branch_based_ordering &&
        !this.props.branch.branch &&
        this.props.settings.branch_count !== 1 &&
        totalCartLength <= 0 ? (
          <ActionButton
            action={
              customTexts
                ? language == "english"
                  ? customTexts.select_location
                  : customTexts.select_location_ar
                : language == "english"
                  ? "Select your location"
                  : "اختر منطقتك"
            }
            onClick={() => this.props.history.push("/select/branch")}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.store.store.categories,
    cart: state.cart,
    branch: state.branch,
    settings: state.store.store.settings,
    language: state.store.language,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
    customerContact: state.customers?.customerContact,
    orderPassVerifiedPhone: state.customers?.orderPassVerifiedPhone,
    orderPassGuestBypassPhone: state.customers?.orderPassGuestBypassPhone,
  };
};
export default withRouter(connect(mapStateToProps)(index));
